import { Button, defineStyle } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { ConnectWalletContext } from '../../context/ConnectWalletContext';

const addNetworkButtonStyles = defineStyle({
  variant: 'outline',
  borderRadius: '12px',
  border: '2px solid',
  borderColor: 'borderGrey.100',
  fontSize: { base: '10px', sm: '12px' },
  lineHeight: '22.5px',
  fontWeight: 500,
  _hover: { borderColor: 'green.100' },
  height: '34px',
});

export const AddNetworkButton = React.memo(() => {
  const { switchNetworkCallback } = useContext(ConnectWalletContext);

  return (
    <Button {...addNetworkButtonStyles} onClick={switchNetworkCallback}>
      Add CratD2C Test Network
    </Button>
  );
});
